import React from 'react';
import { createRoot } from 'react-dom/client';
import Routes from './Routes';
import './styles/tailwind.css';
import './styles/index.css';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>
);